// @flow
import { connect } from "react-redux";

import { updateFormAttribute } from "../actions/FormAttributeSet";
import {
  addRepeatableAttributeSet,
  cancelRepeatableAttributeSet,
  removeRepeatableAttributeSet,
} from "../actions/FormAttributeSetRepeatable";

import type { ThunkAction, UpdateFormOptions, Dispatch } from "../types";
import type { UpdateFormAction } from "../_modularui/types";
import type { AttributeType } from "../../models/types";
import type FormModel from "../../models/form/FormModel";
import type FormObjectModel from "../../models/form/FormObjectModel";
import type { ComponentType } from "react";

type OwnProps = {
  form: FormModel,
  object: FormObjectModel,
  formLayout?: "vertical" | "horizontal" | "compact",
  autosubmit?: boolean,
  autosave?: boolean,
  autoupdate?: boolean,
};

type DispatchProps = {
  onAttributeChange: (
    attribute: AttributeType,
    value: string,
    options: UpdateFormOptions,
  ) => ThunkAction<>,
  onAddAttributeSetClick: () => UpdateFormAction,
  onCancelAttributeSetClick: (formObject: FormObjectModel) => UpdateFormAction,
  onRemoveAttributeSetClick: (formObject: FormObjectModel) => UpdateFormAction,
};

type Props = {
  ...OwnProps,
  ...DispatchProps,
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: OwnProps,
): DispatchProps => ({
  onAttributeChange: (
    attribute: AttributeType,
    value: string,
    options: UpdateFormOptions = {
      autosubmit: ownProps.autosubmit ?? false,
      autosave: ownProps.autosave ?? false,
      autoupdate: ownProps.autoupdate ?? false,
    },
  ) =>
    dispatch(
      updateFormAttribute(
        ownProps.form,
        ownProps.object,
        attribute,
        value,
        options,
      ),
    ),
  onAddAttributeSetClick: () =>
    dispatch(addRepeatableAttributeSet(ownProps.form)),
  onCancelAttributeSetClick: (formObject: FormObjectModel) =>
    dispatch(cancelRepeatableAttributeSet(ownProps.form, formObject)),
  onRemoveAttributeSetClick: (formObject: FormObjectModel) =>
    dispatch(removeRepeatableAttributeSet(ownProps.form, formObject)),
});

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useAttributeSet' or 'useFormNavigation' instead
 */
export const connectFormAttributeSet: ComponentType<any> = connect<
  Props,
  OwnProps,
  _,
  DispatchProps,
  _,
  _,
>(null, mapDispatchToProps);
